import { module } from 'modujs';
import modularLoad from 'modularload';
import shared from '../shared';
import { $html, $body } from '../utils/dom';
import { updateDocumentHead } from '../utils/head';
import gsap from "gsap";
import lottie from "lottie-web";

const SWEEP_DURATION = 0.7;

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.isInitialBoot = true;
        this.loaderSettled = false;
        this.hideTimeline = null;
        this.pendingSharedRoot = document;

        this.load = new modularLoad({
            enterDelay: 300,
            transitions: {
                customTransition: {}
            }
        });

        this.DOM = {
            loading: document.querySelector('.o-loading'),
            logo: document.querySelector('.o-loading_logo'),
            logoLetters: document.querySelectorAll('.o-loading_logo_letter'),
            pct: document.querySelector('.o-loading_pct'),
            pctValue: document.querySelector('.o-loading_pct_value'),
            lottie: document.querySelector('.o-loading_lottie'),
            fake: document.querySelector('.o-loading_fake'),
            bgMain: document.querySelector('.o-loading_background.-main'),
            bgSecond: document.querySelector('.o-loading_background.-second')
        };

        this.lottieAnim = null;

        if (this.DOM.lottie) {
            this.lottieAnim = lottie.loadAnimation({
                container: this.DOM.lottie,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: this.DOM.lottie.getAttribute('data-lottie-src'),
            });
            this.DOM.lottie.setAttribute('data-lottie-id', this.lottieAnim.animationID);
        }

        window.addEventListener('loading-hide', () => {
            this.hide(0);
        }, { once: true });
        window.addEventListener('loading-pct', () => {
            this.hide(0);
        }, { once: true });

        this.load.on('loading', () => {
            this.show(true);
        });

        this.load.on('loaded', () => {
            updateDocumentHead(this.load.data);

            this.pendingSharedRoot = this.load.newContainer || document;

            document.querySelectorAll(".wpcf7 > form").forEach((
                function(e){
                    return wpcf7.init(e)
                }
            ));

            this.setNewBodyClass();

            this.hide(0, true);

            this.call('destroy', this.load.oldContainer, 'app');
            this.call('update', this.load.newContainer, 'app');
        });
        
    }

    hideLoaderChrome() {
        if (this.DOM.logo) {
            gsap.set(this.DOM.logo, { opacity: 0 });
        }
        if (this.DOM.pct) {
            gsap.set(this.DOM.pct, { opacity: 0 });
        }
        if (this.DOM.lottie) {
            gsap.set(this.DOM.lottie, { opacity: 0 });
        }
        if (this.DOM.bgMain) {
            gsap.set(this.DOM.bgMain, { yPercent: -100 });
        }
    }

    show(isNavigation = false) {
        this.call('stop', 'Scroll');
        this.DOM.loading?.classList.remove('-hidden');
        this.hideLoaderChrome();

        if (!this.DOM.bgSecond) return;

        gsap.set(this.DOM.bgSecond, { yPercent: 100 });
        gsap.to(this.DOM.bgSecond, {
            yPercent: 0,
            duration: SWEEP_DURATION,
            ease: 'expo.inOut',
        });
    }

    hide (delay = 0, isNavigation = false) {
        if (this.loaderSettled && !isNavigation) {
            return;
        }

        if (!this.DOM.loading) {
            const dispatchPageLoaded = !isNavigation;
            this.preparePageReveal({ dispatchPageLoaded });
            this.finishLoader();

            if (dispatchPageLoaded) {
                requestAnimationFrame(() => {
                    window.dispatchEvent(new Event('p-loaded'));
                });
            }

            this.isInitialBoot = false;
            return;
        }

        if (this.hideTimeline) {
            this.hideTimeline.kill();
        }

        this.hideLoaderChrome();
        this.preparePageReveal({ dispatchPageLoaded: !isNavigation });

        let tl = gsap.timeline({ delay: delay, onComplete: () => {
            this.finishLoader();
            this.isInitialBoot = false;
        } });

        this.hideTimeline = tl;

        if (!isNavigation) {
            tl.call(() => {
                window.dispatchEvent(new Event('p-loaded'));
            }, null, SWEEP_DURATION * 0.5);
        }

        if (this.DOM.bgSecond) {
            tl.fromTo(this.DOM.bgSecond,
                { yPercent: 0 },
                { yPercent: -100, duration: SWEEP_DURATION, ease: 'expo.inOut' },
                0
            );
        }
    }

    preparePageReveal({ dispatchPageLoaded = true } = {}) {
        const sharedRoot = this.pendingSharedRoot || document;
        this.pendingSharedRoot = document;

        shared(sharedRoot);
        document.dispatchEvent(new Event('loader:hide'));

        if (dispatchPageLoaded) {
            this.call('prepIntro', 'Page');
            $html.classList.remove('is-loading');
        }
    }

    finishLoader() {
        this.loaderSettled = true;
        this.DOM.loading?.classList.add('-hidden');
        this.call('start', 'Scroll');
    }

    setNewBodyClass () {
        if (this.el.querySelector('[data-bodyclass]')) {
            let bodyClass = this.el.querySelector('[data-bodyclass]').getAttribute('data-bodyclass');
            $body.className = bodyClass;
        }
    }
}
